// Vars //
var $body = jQuery('body');

// /* Hide Menu on Browser Resize */
function mobileMenuResizer() {
    $body.find('.js-mobile-trigger').removeClass('active');
    $body.removeClass('hamburger-menu-active');
    $body.removeClass('no-scroll');
}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Product Slider
 * Used for multiple blocks - Feature Product Slider, Feature Category Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });
    });
}



/**
 * 
 * Logo Slider Block - sc-logo-slider-block.twig
 * 
 */
function logoSliderBlockSetup() {
    jQuery('.logo-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.logo-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Icon Slider Block - sc-logo-slider-block.twig
 * 
 */
function iconSliderBlockSetup() {
    jQuery('.icon-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.icon-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = true,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 767) {
           centerMode = false,
           slidesToShow = 3
        } 

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });

      
    });
}

/**
 * 
 * Staggered Image CTA Block
 * 
 */
function staggeredImageCtasSetup() {
    jQuery('.image-ctas-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.image-ctas-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = true,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1300) {
            centerMode = false,
            slidesToShow = 5
         } else if (jQuery(window).width() > 767) {
            centerMode = false,
            slidesToShow = 3
        }
      

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>',
        });

      
    });
}

/**
 * 
 * Staggered Image CTA Block
 * 
 */
function galleryBlockSetup() {
    jQuery('.gallery-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.gallery-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = true,
            slidesToShow = 2,
            slidesToScroll = 1;
            rows = 2;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1300) {
            centerMode = false;
            slidesToShow = 5;
            rows = 1;
         } else if (jQuery(window).width() > 767) {
            centerMode = false;
            slidesToShow = 3;
            rows = 1;
        }
      

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            rows: rows,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });

      
    });

    jQuery('.gallery-block').each(function() {
        $gallery = jQuery(this);

        $gallery.find('.gallery-item__image').magnificPopup({
            type:'image',
            gallery: {
                enabled: true
            }
        });
    })

    jQuery('.gallery-grid-container').masonry({
        // options
        itemSelector: '.gallery-item',
        columnWidth: '.grid-sizer',
        percentagePosition: true,
        gutter: 50
      });
}

/**
 * 
 * Staggered Image CTA Block
 * 
 */
function accommodationBlockSetup() {
    jQuery('.accommodation-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.accommodation-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = true,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1300) {
            centerMode = false,
            slidesToShow = 4
         } else if (jQuery(window).width() > 767) {
            centerMode = false,
            slidesToShow = 2
        }
      

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });

      
    });
}

function reviewsBlockSetup() {
    jQuery('.reviews-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.reviews-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }


        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });


    });
}


function itineraryBlockSetup() {
    
    jQuery('.tour-itinerary-block').each(function() {
        $itineraryBlock = jQuery(this);


        /** 
         * 
         * Itinerary block tab titles slider/logic 
         * 
         * */
        $stopsListContainer = $itineraryBlock.find('.stops-list-slider-container');
        $stopsListContainer.find('.slick-initialized').slick('unslick');
        $stopsListSlider = $stopsListContainer.find('.slider');
        $controls = $stopsListContainer.find('.slider-controls');

        // need to add a little bit of custom handling for the tabs as bootstrap defaults break when the tab list it put into a slick slider
        $stopsListSlider.find('a').on('click', function(event) {
            event.preventDefault();
            $oldActive = $stopsListSlider.find('a.active');
            if($oldActive[0] != jQuery(this)[0]) {
                $stopsListSlider.find('a.active').removeClass('active').attr('aria-selected', false);
                jQuery(this).tab('show');
            }
        })

       

        if($stopsListSlider[0].scrollWidth > $stopsListSlider[0].clientWidth) {
            $stopsListSlider.slick({
                infinite: false,
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                appendArrows: $controls,
                initialSlide: 0,
                prevArrow:
                    '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
                nextArrow:
                    '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
            })
        }


        // reinit activities slick slider when a tab opens
        $stopsListSlider.find('a').on('shown.bs.tab', function(event) {
            $tabButton = jQuery(event.target);
            target = $tabButton.attr('aria-controls');
            setupActivitiesSlider(jQuery('#'+target).find('.stop-activities-slider-container'));
        });



        /**
         * 
         * Itinerary block activities sliders
         * 
         */
        setupActivitiesSlider($itineraryBlock.find('.stops-tabs-content .tab-pane.active .stop-activities-slider-container'));
    });

}

function setupActivitiesSlider($sliderContainerElement) {
    var $activitiesSlider = $sliderContainerElement.find('.slider'),
    $activitiesSliderControls = $sliderContainerElement.find('.slider-controls'),
    centerMode = false,
    slidesToShow = 2;

    $sliderContainerElement.find('.slick-initialized').slick('unslick');
    if(jQuery(window).width() > 1700) {
        centerMode = false;
        slidesToShow = 3;
    } else if (jQuery(window).width() > 767) {
        centerMode = false;
        slidesToShow = 2;
    }

    $activitiesSlider.slick({
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: slidesToShow,
        centerMode: centerMode,
        appendArrows: $activitiesSliderControls,
        prevArrow:
            '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
        nextArrow:
            '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
    })
}

/**
 * 
 * Staggered Image CTA Block
 * 
 */
function toursBlockSetup() {
    jQuery('.tours-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.tours-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = true,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1,
            centerPadding = '50px';

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1300) {
            //centerMode = false,
            slidesToShow = 4
         } else if (jQuery(window).width() > 767) {
            //centerMode = false,
            slidesToShow = 3
        }
      

        // back out of function if the block is a grid layout, we dont need to do the slick slider
        if($container.closest('.tours-block').hasClass('tours-layout-grid') && jQuery(window).width() > 767) {
            return; 
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>',
            centerPadding: centerPadding
        });

      
    });
}

/**
 * Tour Guide Slider
 *
 * @todo: looks like we are creating individual functions for sliders that appear to work largely the same way. Perhaps we can do this better.
 */
function tourGuidesBlockSetup() {
    jQuery('.tour-guides-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.tour-guides-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = true,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 767) {
            centerMode = false;
            slidesToShow = 3
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-long-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-long-arrow-right"></i></span></a>'
        });

    });
}

function openTourModalFormSetup(){
    jQuery('.open-tour-form-modal').click(function (){
        jQuery('#tours-apply-now-form').modal('show');
    })
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}